// /auth/callback — Figma frames 05 callback-working (33:1439) and 06 callback-failed
// (33:1456): one route, two states. Owner: screens-auth-b, US-091 + US-092.
// Pre-login: deliberately no AppShell.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { CallbackScreen } from "../screens/invite/CallbackScreen";

export const authCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/callback",
  component: CallbackScreen,
});
